import React, { forwardRef } from 'react';
import { cn } from '@ais-ui/utils';

export type KbdProps = React.HTMLAttributes<HTMLElement>;

export const Kbd = forwardRef<HTMLElement, KbdProps>(
  ({ children, className, ...props }, ref): JSX.Element => {
    return (
      <kbd
        {...props}
        className={cn(
          'border rounded px-2 py-1 bg-gray-200 text-black inline-flex items-center',
          className
        )}
        ref={ref}
      >
        {children}
      </kbd>
    );
  }
);
